export const codeIcon = "fad fa-code";
export const terminalIcon = "fad fa-terminal";
export const upIcon = "fad fa-angle-up";
export const downIcon = "fad fa-angle-down";
export const searchIcon = "fad fa-search";
